<template>
    <div>
        <div class="grid-container">
            <div class="grid-x">
                <div class="head head--blue cell">
                    <div class="head__content">
                        <h1 class="head__title">{{labels.searchForAStudy}}</h1>
                        <div class="grid-container" v-if="filter">
                            <div class="grid-x grid-margin-x hide-for-print align-center">
                                <div class="search medium-10 large-8 cell">
                                    <label class="show-for-sr" for="search">{{filter.searchText.title}}</label>
                                    <input type="search" id="search" class="search__input" v-model="filter.searchText.text" @keyup.enter="search()" :placeholder="filter.searchText.title" v-focus />
                                    <a @click="search()" @keypress.enter="search()" aria-label="Søg" class="search__button icon-search" tabindex="0"></a>
                                </div>
                            </div>
                            <h2 class="h3 text-center">{{labels.refineSearchTo}}</h2>
                            <br />
                            <div class="grid-x grid-margin-x hide-for-print">
                                
                                


                                <template v-for="(dropdown, k, i) of filter" >
                                     <dropdown :key="i" v-if="k !== 'searchText' && dropdown !== null" 
                                            class="cell large-4 dropdown--small"
                                            :config="dropdown.options"
                                            :label="dropdown.title"
                                            :type="dropdown"
                                            :button-label="'vis jobeffekter2'"
                                            :isSingleSelect="true"
                                            @update="update">
                                    </dropdown>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-container" :class="{'loader__wrapper--loading': searching || forceWait}">
            <div class="loader">
                <div class="loader__circle"></div>
                <div class="loader__text">{{labels.updating}}</div>
            </div>
            <div class="grid-x" v-if="!searching && !forceWait">
                <div v-if="role === 'researcher' && studies !== null" class="cell buttons">
                    <div class="buttons__group stacked-for-small buttons__group--right-large">
                        <button :disabled="exportRunning" @click="saveAsExcell()" @keyup.enter="saveAsExcell()" class="button" tabindex="0">
                            <span class="icon-file-excel"></span>
                            Excel
                        </button>
                    </div>
                </div>
                <div class="content__no-results" v-if="studies === null">
                    <p class="lead">{{labels.useTheSearchBoxAbove}}</p>
                </div>
                <div class="content__no-results" v-else-if="studies.length === 0">
                    <p class="lead">{{labels.noStudiesFound}}</p>
                </div>
                <template v-else>
                    <div class="table__wrapper cell">
                        <table class="table table--study">
                            <caption>
                                <h2 class="table--h2">{{labels.studyList}} ({{studies.length}} {{ latestOnly ? labels.studyCountLatest : labels.studyCount }})</h2>
                            </caption>
                            <thead>
                                <tr>
                                    <th>{{labels.titleOfStudy}}</th>
                                    <th>{{labels.author}}</th>
                                    <th>{{labels.yearOfPublication}}</th>
                                    <th>{{labels.targetGroups}}</th>
                                    <th>{{labels.interventions}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="studies">
                                <tr v-for="(study, k, i) of studies" 
                                    :key="i" 
                                    @click="openStudy(study.id)" 
                                    @keyup.enter="openStudy(study.id)" 
                                    :title="study.title" 
                                    tabindex="0">
                                    <td class="icon-circle-right">{{trimmedTitle(study.title)}}</td>
                                    <td>{{study.authors}}</td>
                                    <td>{{study.publicationYear}}</td>
                                    <td>{{ study.targetGroups.join(', ') }}</td>
                                    <td>{{ study.activities.join(', ') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style>

.form__select-items{
    max-height: 300px;
    overflow-y: scroll;
    display: none;
}

.form__select-items--open{
    display: inline-block;
}

</style>

<script>
import { each } from 'lodash'
export default {
  data() {
    return {
      forceWait: false,
      filter: null,
      latestOnly: false,
      role: window.vm.role || 'public',
      exportRunning: false,
    };
  },
  computed: {
    studies() {
      return this.$store.state.studySearch;
    },
    searching() {
        return this.$store.state.searching;
    },
    labels() {
        return this.$store.state.labels['pages.studysearch'] || { };
    }
  },
  methods: {
    openStudy(studyId) {
        this.$router.push({ name: "Study", params: { id: studyId } });
    },
    searchNewest() {
        this.latestOnly = true;
        this.$store.dispatch("studySearchNewest");
        this.forceWait = true;
        setTimeout(() => (this.forceWait = false), 600);
    },
    search() {
        this.latestOnly = false;
        this.$store.dispatch("studySearch", this.filter);
        this.forceWait = true;
        setTimeout(() => (this.forceWait = false), 600);
    },
    saveAsExcell() {
        this.exportRunning = true;
        this.$store.dispatch('studySearchExport', this.filter).then((e) => {
            setTimeout((e) => {
                this.exportRunning = false;
            }, 800);
        })
    },
    trimmedTitle(title) {
      if (title.length > 65) {
        title = title.slice(0, 55) + "...";
      }
      return title;
    },
    update(data) {
        
        var dropdown = data.type;
        var selectedOptionId = data.selectedItem === null 
        ? 'all'
        : data.selectedItem.id

        dropdown.selected = selectedOptionId;
        this.search();
    }
  },
  mounted() {
    let newest = (this.$route.query.hasOwnProperty('newest') && this.$route.query.newest);

    if (this.studies === null) {
        // Get fresh filter from endpoint
        this.$store.dispatch("getStudySearchFilter").then((filter) => {
            this.filter = filter;
            if (!newest) this.search();
        });

        if (newest) this.searchNewest();
    } else {
        this.filter = this.$store.state.studySearchFilter;
    }

    this.$store.dispatch('getLabels', { label: 'pages.studysearch' });
  }
};
</script>

<style lang="scss" scoped>

    .form__item {
        margin-top: 0;
    }

    .sort {
        margin-top: rem-calc(60);
    }

    .search {
        position: relative;
        margin-bottom: rem-calc(20);
        margin-top: rem-calc(30);
        padding-right: rem-calc(48);

        @include breakpoint(large) {
            margin-top: rem-calc(50)
        }
    }

    .search__input {
        padding: rem-calc(12 10 10 20);
    }

    .search__button {
    position: absolute;
    right: rem-calc(-5);
    top: rem-calc(0);
    color: $white;
    font-size: rem-calc(30);
    opacity: 0.7;
    padding: rem-calc(7 9);

        &:hover,
        &:focus {
            opacity: 1;
        }
    }

    .head__content {
        padding-bottom: rem-calc(40);
    }
</style>



// WEBPACK FOOTER //
// src/components/study-search/StudySearch.vue